module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/mackenzie-800.91d5d17d1e00b99c.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/mackenzie-800.91d5d17d1e00b99c.jpg",width: 800,height: 533}],
        src: "https://static.sniffspot.com/packs/img/mackenzie-800.91d5d17d1e00b99c.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/mackenzie-800.91d5d17d1e00b99c.jpg"},
        
        width: 800,
        height: 533
      }